export enum MediaType {
  IMAGE = 'IMAGE',
  VIDEO = 'VIDEO',
  FRAME = 'FRAME',
  FILE = 'FILE',
  AUDIO = 'AUDIO',
  CALCULATOR = 'CALCULATOR',
  CONVERTER = 'CONVERTER',
  PAPER_EXAM = 'PAPER_EXAM',
  VOCAB_CARD = 'VOCAB_CARD',
  VOCAB_LIST = 'VOCAB_LIST',
  VOCAB_LIST_PRE = 'VOCAB_LIST_PRE',

  VOCAB_LIST_NEWS = 'VOCAB_LIST_NEWS',
}

export interface MediaProps {
  id?: string;
  isPreview?: boolean;
  url?: string;
  element?: any;
  noDeleteBtn?: boolean;
  isEmailMode?: boolean;
  withoutStore?: boolean;
}

export enum AudioViewModeEnum {
  LONG = 'LONG',
  SHORT = 'SHORT',
}
